function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-CCM-Cloud"
}, /*#__PURE__*/React.createElement("rect", {
  width: 78,
  height: 78
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "CCM-Cloud",
  clipPath: "url(#clip-CCM-Cloud)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_4899",
  "data-name": "Grupo 4899",
  transform: "translate(4.229 10.32)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Subtra\\xE7\\xE3o_1",
  "data-name": "Subtra\\xE7\\xE3o 1",
  d: "M55.633,43.232h0v-4.82a10.019,10.019,0,0,0,4.013-1.232,9.558,9.558,0,0,0,3.609-3.493,9.553,9.553,0,0,0,0-9.689A9.553,9.553,0,0,0,59.647,20.5a10.1,10.1,0,0,0-4.693-1.273c.058,0,.059.006.06.007a7.332,7.332,0,0,1-.839.064l-2.1.075L51.613,17.5A16.314,16.314,0,0,0,48.237,11a17.7,17.7,0,0,0-27.2.338l-.931,1.2-1.553-.375a4.955,4.955,0,0,0-1.165-.15,4.9,4.9,0,0,0-3.531,1.39,4.587,4.587,0,0,0-1.436,3.417l.311,2.479-1.707.676a9.842,9.842,0,0,0-4.386,3.53,9.181,9.181,0,0,0-1.669,5.332,9.34,9.34,0,0,0,1.319,4.845A9.567,9.567,0,0,0,9.9,37.179c.175.1.356.192.536.279v5.148a14.788,14.788,0,0,1-2.981-1.3,15.024,15.024,0,0,1-5.433-5.258A13.506,13.506,0,0,1,0,28.917a12.771,12.771,0,0,1,2.1-7.061,15.941,15.941,0,0,1,5.356-5.032,8.945,8.945,0,0,1,1.358-4.807,10.362,10.362,0,0,1,3.609-3.493,9.71,9.71,0,0,1,4.967-1.314,3.411,3.411,0,0,1,.621.075l.388.076a23,23,0,0,1,7.219-5.333,21.89,21.89,0,0,1,18.239-.075A21.285,21.285,0,0,1,51.032,7.1a22.8,22.8,0,0,1,4.618,7.549,15.835,15.835,0,0,1,6.985,2.215,14.432,14.432,0,0,1,5.045,5.071,13.405,13.405,0,0,1,1.862,6.909,13.638,13.638,0,0,1-2.018,7.211,15.028,15.028,0,0,1-5.432,5.258,14.716,14.716,0,0,1-6.457,1.922Z",
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_349",
  "data-name": "Caminho 349",
  d: "M1.563-7.5H29.627V27.959H1.563V-7.5ZM4.369-4.545V2.842H26.82V-4.545Zm0,10.342v8.865H26.82V5.8Zm0,11.82V25H26.82V17.617Z",
  transform: "translate(17.561 30.096)",
  strokeWidth: 0.5
})));

function SvgCcmCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 78 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcmCloud);
export default __webpack_public_path__ + "static/media/ccm-cloud.c3eeb41a.svg";
export { ForwardRef as ReactComponent };